import React from "react";
import { Container, Row } from "reactstrap";
import FooterAction from "./FooterAction";
import dataProvider from "../services/DataProvider";



import logoFooter from '../assets/img/8.png';

const style = {
    root: {
        color: '#FFF',
        textAlign: 'center',
        marginTop: 30,
        display: 'grid'
    },
    titulo: {
        fontSize: '14pt',
        marginTop: '1.3rem',
        textAlign: 'center',
    }
}

const Footer = (props) => {

    const [info, setInfo] = React.useState({})

    React.useEffect(() => {

        dataProvider.getAll('WsSanEndPoints.rule?sys=SAS').then((response) => {
            if (typeof response.data.rodape !== 'undefined') {
                setInfo(response.data.rodape)
            }

        })

    }, []);



    return (<footer >
        <Container >
            <Row className="text-center">
                <div className="col-md-3" style={style.root}>
                    <h6 style={style.titulo}>Acesso rápido</h6>

                    <FooterAction
                        handleIndicadores={props.handleIndicadores}
                        setVisible={props.setVisible}
                        handleMapas={props.handleMapas}
                        handleFaleConosco={props.handleFaleConosco}
                        handlePaineisControle={props.handlePaineisControle} 
                        handleRelatorios={props.handleRelatorios}/>

                </div>

                <div className="col-md-6" style={style.root}>
                    <h6 style={style.titulo}>Atendimento ao cidadão</h6>

                    <span>{info ? info.ORG_ENDERECO : " "}</span>
                    <span>{info ?`Fone: ${info.ORG_FONE}` : " "}</span>
                    <span>{info ? `E-mail: ${info.ORG_EMAIL}` : " "}</span>

                </div>
                <div className="col-md-3 logo-footer text-center">
                    <img src={logoFooter} alt=""></img>
                </div>
            </Row>
        </Container>

    </footer>)
}

export default Footer;